// ReportPendingPanel — pending reports panel with priorities and actions
import { pendingReports } from "@/mocks/relatorios";

const priorityConfig: Record<string, { bg: string; text: string }> = {
  "Alta": { bg: "bg-red-100 text-red-700", text: "text-red-700" },
  "Média": { bg: "bg-orange-100 text-orange-700", text: "text-orange-700" },
  "Baixa": { bg: "bg-background-200 text-foreground-500", text: "text-foreground-500" },
};

export default function ReportPendingPanel() {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-100">
        <h3 className="text-sm font-semibold text-foreground-900">Pendências de Relatórios</h3>
        <span className="text-xs text-foreground-400">{pendingReports.length} pendências</span>
      </div>
      <div className="divide-y divide-background-100">
        {pendingReports.map((p) => {
          const pc = priorityConfig[p.priority] || { bg: "bg-background-100 text-foreground-500", text: "text-foreground-500" };
          return (
            <div key={p.id} className="px-4 py-3 hover:bg-background-50 transition-colors">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{p.title}</div>
                  <div className="text-xs text-foreground-400 mt-0.5">{p.reason}</div>
                  <div className="flex items-center gap-3 mt-2">
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${pc.bg}`}>
                      <i className="ri-flag-line w-3 h-3 flex items-center justify-center" />
                      {p.priority}
                    </span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-calendar-line w-3 h-3 inline-flex items-center justify-center mr-1" />
                      Até {p.dueDate}
                    </span>
                  </div>
                </div>
                <button className="px-3 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap shrink-0">
                  {p.action}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}